const infoPoints = [
  [
    { text: 'Each ' },
    { text: 'entity', strong: true },
    { text: 'can have' },
    { text: 'one default commission rule:', strong: true },
    { text: 'either percentage (%) or fixed AED amount.' },
  ],
  [
    { text: 'Click' },
    {
      text: '+ Add Another Entity',
    },
    { text: 'to set up more rules (no duplicates allowed).' },
  ],
  [
    { text: 'These rules apply ' },
    { text: 'globally', strong: true },
    { text: ', all LeadXchange pool environments.' },
  ],
  [
    {
      text: 'Error shown if an entity is configured twice or commission value is blank/invalid.',
    },
  ],
  [{ text: 'Global System Behavior:', strong: true }],
  [
    { text: 'Return Closed Leads to Pool:', strong: true },
    { text: ' Closed leads are returned to the ' },
    { text: 'LeadXchange pool', strong: true },
    { text: ' for other agents to claim.' },
  ],
  [
    { text: 'Allow Reclaim by Previous Agent:', strong: true },
    { text: ' Previous agents can reclaim leads.' },
  ],
  [
    { text: 'Allow Claim Multiple Leads per Contact:', strong: true },
    { text: ' Agents may claim more than one lead per contact.' },
    { text: ' (If enabled, ' },
    { text: 'Max Claims per Agent per Contact', strong: true },
    { text: ' is required.)' },
  ],
];
export default infoPoints;
